export const WEIKSTUDIO_DOMAIN = 'weikstudio';
